import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const resendAuthCodeByVoiceHandler = restHandlerFactory(
  '/explanation_sign_authentication/trials/{trial_uid}/{explanation_sign_authentication_uid}/resend_by_voice',
  'post',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
